import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import StickerUpdateRequest from "../form/request/StickerUpdateRequest";

const API_PREFIX = "/updateSticker";

export const resizeUpload = async request => {
  const response = await post(`${API_PREFIX}/sendImage`, request, authHeader());
  console.log("response", response);
  return response.data;
};

export const init = async request => {
  const queryParams =
    "?listId=" +
    request.listId +
    "&itemId=" +
    request.itemId +
    "&stickerId=" +
    request.stickerId +
    "&stickerFileName=" +
    request.stickerFileName;

  const response = await get(`${API_PREFIX}/${queryParams}`, authHeader());
  console.log("response", response);
  return response.data;
};

export const checkAndReload = async request => {
  const queryParams = "?listId=" + request.listId + "&fileName=" + request.fileName;
  const response = await get(`${API_PREFIX}/checkAndReload${queryParams}`, authHeader());
  console.log("response", response);
  return response.data;
};

export const update = async request => {
  const response = await post(`${API_PREFIX}/update`, new StickerUpdateRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};
